// src/sdk.ts
import {
  MetorialManagementInstancesActorsEndpoint,
  MetorialManagementInstancesAgentsEndpoint,
  MetorialManagementInstancesClientTokensJwksEndpoint,
  MetorialManagementInstancesFilesEndpoint,
  MetorialManagementInstancesFilesLinksEndpoint,
  MetorialManagementInstancesGroupsBlocksEndpoint,
  MetorialManagementInstancesGroupsEndpoint,
  MetorialManagementInstancesGroupsThreadsEndpoint,
  MetorialManagementInstancesGroupsUsersEndpoint,
  MetorialManagementInstancesInstanceEndpoint,
  MetorialManagementInstancesPoliciesEndpoint,
  MetorialManagementInstancesPoliciesEntitlementsEndpoint,
  MetorialManagementInstancesPortalsAgentsEndpoint,
  MetorialManagementInstancesPortalsEndpoint,
  MetorialManagementInstancesRolesEndpoint,
  MetorialManagementInstancesRunsEndpoint,
  MetorialManagementInstancesThreadsEndpoint,
  MetorialManagementInstancesThreadsMessagesEndpoint,
  MetorialManagementInstancesThreadsParticipantsEndpoint,
  MetorialManagementInstancesUsersEndpoint,
  MetorialManagementProjectsAgentsEndpoint,
  MetorialManagementProjectsAgentsInstanceAgentsEndpoint,
  MetorialManagementProjectsAgentsReleasesEndpoint,
  MetorialManagementProjectsEndpoint,
  MetorialManagementProjectsPortalsEndpoint,
  MetorialManagementProjectsPortalsPortalAgentsEndpoint,
  MetorialManagementProjectsPortalsPortalDomainsEndpoint,
  MetorialManagementProjectsPortalsPortalEnvironmentsEndpoint
} from "@metorial/core";

// src/builder.ts
import { MetorialSDKBuilder } from "@metorial/util-endpoint";
var sdkBuilder = MetorialSDKBuilder.create("metorial-management-api", "2025-01-01-protostar").setGetApiHost((config) => {
  var _a;
  return (_a = config.apiHost) != null ? _a : "https://api.metorial.com";
}).setGetHeaders((config) => {
  var _a;
  return {
    "Metorial-Version": config.apiVersion,
    ...config.apiKey ? { Authorization: `Bearer ${config.apiKey}` } : {},
    ...config.organizationId ? { "Metorial-Organization-Id": config.organizationId } : {},
    ...config.instanceId ? { "Metorial-Instance-Id": config.instanceId } : {},
    ...(_a = config.headers) != null ? _a : {}
  };
});

// src/sdk.ts
var createMetorialManagementSDK = sdkBuilder.build(
  (soft) => ({
    ...soft,
    apiVersion: "2025-01-01-protostar"
  })
)((manager) => ({
  instances: Object.assign(new MetorialManagementInstancesInstanceEndpoint(manager), {
    actors: new MetorialManagementInstancesActorsEndpoint(manager),
    agents: new MetorialManagementInstancesAgentsEndpoint(manager),
    clientTokens: {
      jwks: new MetorialManagementInstancesClientTokensJwksEndpoint(manager)
    },
    files: Object.assign(new MetorialManagementInstancesFilesEndpoint(manager), {
      links: new MetorialManagementInstancesFilesLinksEndpoint(manager)
    }),
    groups: Object.assign(new MetorialManagementInstancesGroupsEndpoint(manager), {
      blocks: new MetorialManagementInstancesGroupsBlocksEndpoint(manager),
      threads: new MetorialManagementInstancesGroupsThreadsEndpoint(manager),
      users: new MetorialManagementInstancesGroupsUsersEndpoint(manager)
    }),
    policies: Object.assign(new MetorialManagementInstancesPoliciesEndpoint(manager), {
      entitlements: new MetorialManagementInstancesPoliciesEntitlementsEndpoint(manager)
    }),
    portals: Object.assign(new MetorialManagementInstancesPortalsEndpoint(manager), {
      agents: new MetorialManagementInstancesPortalsAgentsEndpoint(manager)
    }),
    roles: new MetorialManagementInstancesRolesEndpoint(manager),
    runs: new MetorialManagementInstancesRunsEndpoint(manager),
    threads: Object.assign(new MetorialManagementInstancesThreadsEndpoint(manager), {
      messages: new MetorialManagementInstancesThreadsMessagesEndpoint(manager),
      participants: new MetorialManagementInstancesThreadsParticipantsEndpoint(manager)
    }),
    users: new MetorialManagementInstancesUsersEndpoint(manager)
  }),
  projects: Object.assign(new MetorialManagementProjectsEndpoint(manager), {
    agents: Object.assign(new MetorialManagementProjectsAgentsEndpoint(manager), {
      instanceAgents: new MetorialManagementProjectsAgentsInstanceAgentsEndpoint(manager),
      releases: new MetorialManagementProjectsAgentsReleasesEndpoint(manager)
    }),
    portals: Object.assign(new MetorialManagementProjectsPortalsEndpoint(manager), {
      portalAgents: new MetorialManagementProjectsPortalsPortalAgentsEndpoint(manager),
      portalDomains: new MetorialManagementProjectsPortalsPortalDomainsEndpoint(manager),
      portalEnvironments: new MetorialManagementProjectsPortalsPortalEnvironmentsEndpoint(
        manager
      )
    })
  })
}));
export {
  createMetorialManagementSDK
};
//# sourceMappingURL=index.js.map